module.exports = __webpack_public_path__ + "static/media/sendBlack.6c8d25e3.svg";